export default {
  inputLabel: {
    id: 'asp_action_bar_send_message_input_label_seller_side',
    defaultMessage: 'Your message to the agent',
  },
  requiredMessageError: {
    id: 'asp_action_bar_send_message_input_label_required_error_message_seller_side',
    defaultMessage: 'This field is required',
  },
  submit: {
    id: 'asp_action_bar_send_message_submit_button_seller_side',
    defaultMessage: 'Send message',
  },
}
